import { useUserProfileApi } from '@/api/UserProfile'
import { QueryClient, useQuery } from 'vue-query'
import QueryKeys from '@/vue-query/QueryKeys'

export function useUserProfileQuery() {
  const client = useUserProfileApi()

  return useQuery({
    queryKey: [QueryKeys.UserProfile],
    queryFn: () => client.get(),
  })
}

export function useUserProfileQueryPrefetch(
  queryClient: QueryClient,
): Promise<void> {
  const client = useUserProfileApi()
  return queryClient.prefetchQuery({
    queryKey: [QueryKeys.UserProfile],
    queryFn: () => client.get(),
  })
}
